import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronUpSquare: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', ry: '2' }],
    ['polyline', { points: '8,14 12,10 16,14' }],
  ],
];

export default ChevronUpSquare;
